// Dialog zum Wählen/Ändern des Games-Usernames. Spieler treten in den
// Ranglisten nur mit diesem Namen auf, nie mit ihrem Google-Namen.
import { useState } from "react";
import { X, User } from "lucide-react";
import { validateUsername, USERNAME_MAX } from "./gamesFirebase";

export default function UsernameDialog({ initial, onSave, onClose }) {
  const [value, setValue] = useState(initial || "");
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    const invalid = validateUsername(value);
    if (invalid) {
      setError(invalid);
      return;
    }
    setSaving(true);
    const result = await onSave(value.trim());
    setSaving(false);
    if (result.ok) onClose();
    else setError(result.error);
  };

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm">
      <div className="relative w-full max-w-sm bg-[#15171c] border border-white/10 rounded-2xl p-6">
        {initial && (
          <button
            onClick={onClose}
            aria-label="Schließen"
            className="absolute top-4 right-4 text-white/40 hover:text-white transition-colors"
          >
            <X size={16} />
          </button>
        )}

        <div className="flex items-center gap-2 mb-1 text-white">
          <User size={16} />
          <h2 className="text-lg font-bold tracking-tight">
            {initial ? "Username ändern" : "Wähle deinen Username"}
          </h2>
        </div>
        <p className="text-sm text-white/55 leading-relaxed mb-5">
          Mit diesem Namen erscheinst du in den Weltranglisten.
        </p>

        <input
          autoFocus
          type="text"
          value={value}
          maxLength={USERNAME_MAX}
          onChange={(e) => {
            setValue(e.target.value);
            setError(null);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") submit();
            e.stopPropagation();
          }}
          placeholder="z. B. pixelkoenig"
          className="w-full bg-white/[0.06] border border-white/15 rounded-xl px-4 py-3 text-sm text-white placeholder:text-white/30 outline-none focus:border-white/40 transition-colors"
        />
        {error && <p className="mt-2 text-xs text-red-400">{error}</p>}

        <button
          onClick={submit}
          disabled={saving}
          className="mt-4 w-full py-3 rounded-full bg-white text-zinc-900 text-xs font-bold uppercase tracking-widest hover:opacity-90 transition-opacity disabled:opacity-50"
        >
          {saving ? "Speichern…" : "Speichern"}
        </button>
      </div>
    </div>
  );
}
